import React, { Component } from 'react';
import { Box, MenuItem, TextField, Typography } from '@mui/material';
import Select from '@mui/material/Select';
import config from '../../config';
import i18n from '../../i18';

class DialogTranslatableField extends Component {
    constructor(props) {
        super(props);
        const initialValue = config.languages.reduce((acc, lang) => {
            acc[lang] = '';
            return acc;
        }, {});
        const parseValue = (value) => {
            try {
                return JSON.parse(value);
            } catch (e) {
                return initialValue;
            }
        };
        const parsedValue = parseValue(props.value);
        const initialLanguage = config.language || 'en';

        this.state = {
            selectedLanguage: initialLanguage,
            value: parsedValue,
            tempInput: parsedValue[initialLanguage] || ''
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const parseValue = (value) => {
            try {
                return JSON.parse(value);
            } catch (e) {
                return config.languages.reduce((acc, lang) => {
                    acc[lang] = '';
                    return acc;
                }, {});
            }
        };

        const parsedValue = parseValue(nextProps.value);

        if (JSON.stringify(parsedValue) !== JSON.stringify(prevState.value)) {
            const selectedLanguage = prevState?.selectedLanguage;
            let tempInput = parsedValue ? selectedLanguage ? parsedValue[selectedLanguage] : '' : '';
            return {
                value: parsedValue,
                tempInput: tempInput,
                selectedLanguage: selectedLanguage
            };
        }
        return null;
    }

    handleChangeLanguage = (e) => {
        const selectedLanguage = e.target.value;
        this.setState({
            selectedLanguage: selectedLanguage,
            tempInput: this.state.value[selectedLanguage] || ''
        });
    };

    handleChange = (e) => {
        const { value } = e.target;
        this.setState((prevState) => {
            const newValue = {
                ...prevState.value,
                [prevState.selectedLanguage]: value
            };
            this.props.onChange(this.props.field.id, JSON.stringify(newValue));
            return { value: newValue, tempInput: value };
        });
    };

    render() {
        const languages = config.languages;
        const translatedLabel = i18n.t(`columns.${this.props.field.label}`);
        const placeholderLabel = i18n.t(
            `placeholder.${this.props.field.label}`
        );

        const required = this.props.field.required;
        const requiredLabel = required ? ' *' : '';

        return (
            <Box
                key={this.props.field.id}
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                sx={{ mb: 2 }}
            >
                <Typography variant="subtitle2" sx={{ mr: 1 }}>
                    {translatedLabel + requiredLabel}
                </Typography>
                <TextField
                    placeholder={placeholderLabel}
                    fullWidth
                    sx={{ mr: 1 }}
                    type="text"
                    id={this.props.field.id}
                    name={this.props.field.id}
                    value={this.state.tempInput}
                    onChange={this.handleChange}
                />
                <Select
                    margin="dense"
                    id={this.props.field.id}
                    value={this.state.selectedLanguage}
                    onChange={this.handleChangeLanguage}
                >
                    {languages.map((lang) => (
                        <MenuItem key={lang} value={lang}>
                            {i18n.t(`languages.${lang}`)}
                        </MenuItem>
                    ))}
                </Select>
            </Box>
        );
    }
}

export default DialogTranslatableField;
